import React, { useEffect, useState } from 'react';

import { filterMethod } from '../../Helpers/helpers';

import { Autocomplete, TextField } from '@mui/material';

const ConstantsAutocomplete = (props) => {
  const setByType = props.setByType;
  const constantsType = props.constantsType;
  const constantTypeUpdate = props.constantTypeUpdate;
  const nameLabel = props.nameLabel;
  const size = props.size;

  const [selectedConstant, setSelectedConstant] = useState({});

  useEffect(() => {
    let Obj = findId(constantsType, options);
    setSelectedConstant(Obj);
  }, [constantsType]);

  const handleChange = (event, newValue) => {
    const filterValue = typeFilterData(newValue?.name);
    setByType(filterValue);
    setSelectedConstant(newValue);
  };

  const typeFilterData = (data) => {
    switch (data) {
      case 'Asset Comp':
        return 'CUS_ASSET_COMP';

      case 'Categories':
        return 'CUS_CATEGORIES';

      case 'Regions':
        return 'CUS_REGIONS';

      default:
        break;
    }
  };

  return (
    <div>
      <Autocomplete
        sx={{
          width: '80%',
          background: '#ffffff',
          padding: 0,
        }}
        name='constantType'
        key='constantType'
        id='constantType'
        variant='standard'
        size={size}
        value={selectedConstant}
        onChange={handleChange}
        disablePortal
        options={options}
        filterOptions={filterMethod}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => <TextField {...params} label={nameLabel} />}
      />
    </div>
  );
};

export default ConstantsAutocomplete;

//Constants Type List
const options = [
  { id: '101', name: 'Asset Comp' },
  { id: '102', name: 'Categories' },
  { id: '103', name: 'Regions' },
];

const optionsNameConverter = (data) => {
  switch (data) {
    case 'CUS_ASSET_COMP':
      return 'Asset Comp';

    case 'CUS_CATEGORIES':
      return 'Categories';

    case 'CUS_REGIONS':
      return 'Regions';

    default:
      break;
  }
};

export const findId = (item, objectSet) => {
  let found = null;
  for (let i = 0; i < objectSet.length; i++) {
    if (objectSet[i].name === optionsNameConverter(item)) {
      found = objectSet[i];
      break;
    }
  }
  return found;
};
